export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500">了解酷漫屋背后的故事</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20manga%20reading%20community%20illustration%20with%20diverse%20characters%20enjoying%20comics%20together%2C%20cozy%20atmosphere%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20modern%20illustration%20style%2C%20friendly%20vibe%2C%20minimal%20background&width=800&height=600&seq=about-manga-01&orientation=landscape"
              alt="酷漫屋平台介绍"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <h3 className="text-lg md:text-xl font-heading text-primary-500 mb-3">
              让每一个漫画爱好者都能免费阅读
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              酷漫屋诞生于一群漫画爱好者的共同心愿——打造一个真正免费、便捷、资源丰富的漫画在线阅读平台。我们深知追漫人的快乐来源于第一时间看到心仪作品的更新，也理解翻遍各大网站找不到一部冷门佳作的苦恼。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              从日漫经典到韩漫热门，从国漫新秀到小众精品，酷漫屋收录超过50,000部漫画作品，覆盖几乎所有你感兴趣的题材类型。我们的下拉式滚动阅读技术让追漫体验更加流畅自然，无需翻页即可沉浸于精彩的故事世界。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              每日200+章节的稳定更新，确保你追的每一部漫画都不会断更。酷漫屋，不只是漫画网站，更是属于每一位漫画爱好者的精神家园。
            </p>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary-100/80">
                <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
                <span className="text-xs text-primary-700 whitespace-nowrap">50,000+漫画</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-accent-100/80">
                <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                <span className="text-xs text-accent-700 whitespace-nowrap">日更200+章</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-secondary-100/80">
                <i className="ri-checkbox-circle-line text-secondary-500 text-sm"></i>
                <span className="text-xs text-secondary-700 whitespace-nowrap">完全免费</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}